'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
exports.daemon = exports.DaemonMode = void 0;
var createDaemon_1 = require('../utils/createDaemon');
var createDaemon_2 = require('../utils/createDaemon');
Object.defineProperty(exports, 'DaemonMode', {
    enumerable: true,
    get: function () {
        return createDaemon_2.DaemonMode;
    },
});
function daemon(mode, action) {
    return function daemonMeta(target, key, descriptor) {
        descriptor.value.__$daemonMode = mode || createDaemon_1.DaemonMode.Sync;
        descriptor.value.__$action = action;
        return descriptor;
    };
}
exports.daemon = daemon;
